import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useReducer
} from 'react'
import {
  initialUserReducer,
  userReducer,
  UserReducerActions
} from './UserReducer'
import { Product } from '../../service/Product/ProductService'
import { checkIfAvailableToWatch, updateUser } from './actions'
import { User } from '../../service/User/UserService'

export const UserContext = createContext<UserReducerActions>(initialUserReducer)

export const UserContextProvider = (props: {
  children: ReactNode
}): JSX.Element => {
  const [userSettings, dispatch] = useReducer(userReducer, initialUserReducer)
  const { children: childComponents } = props

  const userDetails = useMemo(() => userSettings.userDetails, [userSettings])

  const updateUserHandler = useCallback(
    (user: User) => {
      updateUser(user, dispatch)
    },
    [userSettings]
  )

  const checkIfAvailableToWatchHandler = useCallback(
    (product: Product): boolean =>
      checkIfAvailableToWatch(product, userSettings.userDetails),
    [userSettings]
  )

  const isUserLoggedIn = () => !!userSettings.userDetails.id

  const contextValue = useMemo(
    () => ({
      userDetails,
      updateUser: updateUserHandler,
      isUserLoggedIn,
      checkIfAvailableToWatch: checkIfAvailableToWatchHandler
    }),
    [userSettings]
  )

  return (
    <UserContext.Provider value={contextValue}>
      {childComponents}
    </UserContext.Provider>
  )
}
